<template>
  <div class="footer dfac jcc">
    <div class="dfac">
      <span v-if="ICPno1" @click="handleClick(recordCode)" class="wangan-box">
        <img src="@/assets/img/footerImg.png" />
        {{ICPno1}}
      </span>
      <span v-if="ICPno1" class="mr20 ml20">|</span>
      <span v-if="ICPno2" @click="handleClick()" class="wangan-box">{{ICPno2}}</span>

      <span v-if="ICPno2" class="mr20 ml20">|</span>

      <span target="_blank" @click="handleClick(recordCode)" class="wangan-box">
        <img src="http://www.beian.gov.cn/img/new/gongan.png">
        苏公网安备:32010402001783
      </span>

      <span class="mr20 ml20">|</span>
      <span>客服热线:{{servicePhone}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyFooter',
  computed: {
    // ICPno1() {
    //   return this.$store.state.user.platformSettings.length && this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5ICPNumber').values[0].value
    // },
    // ICPno2() {
    //   return this.$store.state.user.platformSettings.length && this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5ICPNumber').values[1].value
    // },
    // servicePhone() {
    //   console.log('1111wwwwww1', this.$store.state.user.platformSettings.length &&this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5servicePhone'))
    //   return this.$store.state.user.platformSettings.length && this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5servicePhone').values[0].value
    // }
  },
  data() {
    return {
      ICPno1: '',
      ICPno2: '',
      servicePhone: '',
      recordCode: ''
    }
  },
  mounted() {
    setTimeout(() => {
      console.log(this.$store.state.user.platformSettings)
      this.servicePhone = this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5servicePhone').values[0].value
      this.ICPno1 = this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5NSNumber').value
      this.ICPno2 = this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5ICPNumber').value
      this.recordCode = this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5NSValue').value
    }, 500)
  },
  methods: {
    handleClick(recordcode) {
      let url = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + recordcode
      if (recordcode) {
        window.open(url, '_blank')
      } else {
        url = 'https://beian.miit.gov.cn/#/Integrated/index'
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 70px;
  line-height: 70px;
  background: white;
  color: black;

  .wangan-box {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      margin-right: 5px;
    }
  }
}
</style>
